import React from "react";
import "./App.css";
import Home from "./components/Home/Home";
import { Route, Routes, Navigate } from "react-router-dom";

import Signin from "./components/Login/Signin";
import Signup from "./components/Login/Signup";
import VideoList from "./components/Video/VideoList";
import DetailVideo from "./components/Video/DetailVideo";
// import Contact from "./components/Contact/Contact";
import ProfessiogrammaHome from "./components/Professiogramma/ProfessiogrammaHome";
import Rtr from "./components/RTR/Rtr";
import DetailProfessiogramma from "./components/Professiogramma/DetailProfessiogramma";
import BoshlangichTalim from "./components/Boshlangich/BoshlangichTalim";
import TextPage from "./components/TextPage/TextPage";
import MediaMaterial from "./components/TextPage/Materiallar/MediaMaterial";
import KorgazmaMaterial from "./components/TextPage/Materiallar/KorgazmaMaterial";
import Test from "./components/Test/Test";
import TestSavollar from "./components/Test/TestSavollar";
import { RtrProvider } from "./components/context/context";
import { ProfProvider } from "./components/context/proffessiogramma_context";
import { VideoProvider } from "./components/context/video_context";
import About from "./components/about/about";
import PageNotFound from "./components/Home/PageNoteFound";
import PasswordReset from "./components/Login/PasswordReset";
import  Email  from "./components/Login/Email";
import TestUmumiy from "./components/Test/TestUmumiy";

function PrivateRoute({ children }) {
  const token = localStorage.getItem("access_token");
  return token ? children : <Navigate to="/signin" />;
}


function App() {
  return (
    <div className="App">
      <RtrProvider>
        <ProfProvider>
          <VideoProvider>
            <Routes>

              <Route path="/" element={<Home />} />
              <Route path="/loyiha-haqida" element={<About />} />


              <Route path="/VideoMaterial" element={<VideoList />} />
              <Route path="/VideoMaterial/:id/" element={<DetailVideo />} />

              <Route path="/contact" element={<Test />} />
              <Route path="/reset-password-form/" element={<PasswordReset />} />
              <Route path="/send-email" element={<Email />} />

              <Route path="/professiogramma" element={<ProfessiogrammaHome />} />

              <Route
                path="/professiogramma/:id/"
                element={<DetailProfessiogramma />}
              />
              <Route path="/rtr" element={<Rtr />} />

              <Route path="/boshlangich/:id/" element={<BoshlangichTalim />} />
              <Route path="/boshlangich-talim/:id/:sub_id" element={<PrivateRoute><TextPage /></PrivateRoute>} />
              {/* <Route path="/1-mavzu" element={<Mavzu />} /> */}
              <Route path="/mediamaterial" element={<MediaMaterial />} />
              <Route path="/korgazma" element={<KorgazmaMaterial />} />
              <Route path="/test/:test_id/:subject_id" element={<Test />} />
              <Route path="/savol/:test_id/:subject_id" element={<TestSavollar />} />
              <Route path="/savollar" element={<TestUmumiy />} />

              <Route path="/signup" element={<Signup />} />
              <Route path="/signin" element={<Signin />} />
              <Route path="404" element={<PageNotFound />} />
              <Route path="*" exact={true} element={<Navigate to="/404" />} />

            </Routes>
          </VideoProvider>
        </ProfProvider>
      </RtrProvider>
    </div>
  );
}

export default App;
